import React from "react";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Shield as ShieldIcon,
  Star as StarIcon,
} from "@mui/icons-material";
import { useClinicTheme } from "../../theme";
import { COLORS } from "../../styles/uiConstants";

/** Personel şablonu listesinin mobil (md altı) kart gösterimi. */
export default function RoleTemplateCard({ template, onEdit, onDelete, canUpdate, canDelete }) {
  const { palette } = useClinicTheme();

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        border: `1px solid ${COLORS.slate200}`,
        bgcolor: COLORS.white,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          flexShrink: 0,
          bgcolor: alpha(palette.primary, 0.1),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ShieldIcon sx={{ fontSize: 20, color: palette.primary }} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "0.875rem", color: COLORS.slate800 }} noWrap>
            {template?.name}
          </Typography>
          {template?.isDefault ? <StarIcon sx={{ fontSize: 14, color: COLORS.warning }} /> : null}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.5 }}>
          <Chip
            size="small"
            label={`${(template?.permissions || []).length} izin`}
            sx={{
              height: 20,
              fontSize: "0.625rem",
              fontWeight: 700,
              bgcolor: alpha(palette.primary, 0.08),
              color: palette.primary,
            }}
          />
          {template?.code ? (
            <Typography
              sx={{
                fontSize: "0.6875rem",
                fontFamily: "'SF Mono', 'Fira Code', monospace",
                fontWeight: 700,
                color: COLORS.slate500,
              }}
            >
              {template.code}
            </Typography>
          ) : null}
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: 0.5, alignSelf: "flex-start", flexShrink: 0 }}>
        {canUpdate ? (
          <IconButton size="small" aria-label="Şablon düzenle" onClick={() => onEdit?.(template)}>
            <EditIcon fontSize="small" />
          </IconButton>
        ) : null}
        {canDelete && !template?.isDefault ? (
          <IconButton
            size="small"
            aria-label="Şablon sil"
            onClick={() => onDelete?.(template)}
            sx={{ color: COLORS.error }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );
}
